import * as React from 'react';
import { Link, FieldProps, useRecordContext, ReferenceManyCount } from 'react-admin';
import { Chapters, Subjects } from '../../custom';
import { useParams } from 'react-router';

const TopicsLinkField = (props: FieldProps<Chapters>) => {
    const record = useRecordContext<Chapters>();
    let { programId, subjectId } = useParams();
    if (!record) {
        return null;
    }
    return (
        <Link to={`/programs/${programId}/subjects/${subjectId}/chapters/${record.id}/topics`}>
            Topics
        </Link>
    );
};

TopicsLinkField.defaultProps = {};

export default TopicsLinkField;
